import React, { useCallback, useContext, useEffect, useState } from 'react'
import { QuestionChoicesStyles } from './Style'
import { WordsContext } from './Words'
import { AnimatePresence } from 'framer-motion'
import { NextButton } from 'pages/School/PerformAssessment'
import * as motion from "motion/react-client"
import { grades } from 'keys'
import { useSelector } from 'react-redux'
import { cloneDeep, isNumber } from 'lodash'

const QuestionChoices = (props) => {
    const { visibleType } = props
    const { isDemo, title, questions, questionValues, setQuestionValues, hideNextButton, hideDisabledNext, changeBoldWordAfterSeconds, boldWordAfterSeconds, wordListPage, handleNext, setWordListPage, wordListIndex, setWordListIndex, finishPerfom, showCartoon } = useContext(WordsContext)

    const [disabledNext, setDisabledNext] = useState(true)
    const [motionKey, setMotionKey] = useState(0);
    const [currentBoldAnswer, setCurrentBoldAnswer] = useState(null)
    const [nextClicked, setNextClicked] = useState(false)

    const currentQuestion = questions?.[wordListIndex]
    const currentQuestionValue = questionValues?.[wordListIndex]
    const disabledGoNext = questions?.length - 1 === wordListIndex

    const { assessment } = useSelector(state => state.assessment)
    const { reading_assessment_grade_of_execution: grade_of_execution } = assessment || {}

    let gradeStyle = grades[grade_of_execution] || {}
    const fontsize = gradeStyle.fontsize?.[visibleType]

    const goPrevPage = useCallback(() => {
        setNextClicked(false)
        setDisabledNext(true)
        setWordListIndex(index => index + 1)
    }, [])

    const handleButtonClick = () => {
        // 1. הגנה מפני לחיצות כפולות (רק אם כבר עברנו שלב)
        if (nextClicked) return;

        const hasCorrectAnswer = isNumber(questionValues?.[wordListIndex]);

        // 2. בדיקה אם באמת אפשר להתקדם
        const canProceed = handleNext || disabledGoNext || hasCorrectAnswer;
        if (canProceed) {
            // רק כאן אנחנו נועלים את הכפתור!
            setNextClicked(true);

            if (handleNext) {
                handleNext();
            } else if (disabledGoNext) {
                finishPerfom?.();
            } else if (hasCorrectAnswer) {
                goPrevPage();
            }
        } else {
            // כאן אפשר להוסיף התראה למשתמש שחובה לבחור תשובה
            console.log("Please select an answer before proceeding");
        }
    }

    const selectAnswer = useCallback((index) => {
        let nQuestionValues = cloneDeep(questionValues)
        if (questionValues[wordListIndex] == index)
            nQuestionValues[wordListIndex] = null
        else nQuestionValues[wordListIndex] = index
        setQuestionValues(nQuestionValues)
    }, [wordListIndex, questionValues])

    useEffect(() => {
        if (disabledNext)
            setTimeout(() => {
                setDisabledNext(false)
            }, 2000);
    }, [disabledNext])

    useEffect(() => {
        if (boldWordAfterSeconds)
            setTimeout(() => {
                setCurrentBoldAnswer(currentBoldAnswer => currentBoldAnswer + 2)
            }, boldWordAfterSeconds)
    }, [])

    useEffect(() => {
        setNextClicked(false);
    }, [wordListIndex]);

    return (
        <QuestionChoicesStyles fontsize={fontsize}>
            <div className='wrap-questions'>
                <AnimatePresence mode="wait">
                    <div className="wrap-go-prev-page">
                        <motion.div
                            initial={{ opacity: 0.5 }}
                            animate={{ opacity: 1 }}
                            exit={{ opacity: 0.5 }}
                            transition={{ duration: 1 }}
                            key={motionKey}
                        >
                            <div className='question-and-answers'>
                                <div className='question'>
                                    <div className='num-question'>
                                        {title ||
                                            <React.Fragment>
                                                {`שאלה מספר ${wordListIndex + 1} `}
                                                <span className='total-questions'>
                                                    {`מתוך ${questions?.length}`}
                                                </span>
                                            </React.Fragment>}
                                    </div>
                                    <div>
                                        {currentQuestion?.text}
                                    </div>
                                </div>
                                <div className='answers'>
                                    {currentQuestion?.answers?.map((answer, index) =>
                                        <div
                                            className={`${currentQuestionValue == index && "selected-answer"} answer ${currentBoldAnswer === index + 1 && "selected-answer"}`}
                                            onClick={() => selectAnswer(index)}>
                                            <div className='answer-number'>{`${index + 1}.`}</div>
                                            {answer.text}
                                        </div>
                                    )}
                                </div>
                            </div>
                        </motion.div>
                    </div>
                    <div className="wrap-go-prev-page">
                        <motion.div
                            initial={{ opacity: 0.5 }}
                            animate={{ opacity: 1 }}
                            exit={{ opacity: 0.5 }}
                            transition={{ duration: 0.7 }}
                            key="go-prev-page"
                        >
                            <div className="go-prev-page">
                                <NextButton
                                    disabled={!isDemo &&
                                        (
                                            disabledNext ||
                                            !isNumber(questionValues?.[wordListIndex])
                                        )}
                                    action={handleButtonClick} />
                            </div>
                        </motion.div>
                    </div>
                </AnimatePresence>
            </div>
        </QuestionChoicesStyles>
    )
}

export default QuestionChoices